import { render, staticRenderFns } from "./GrapesDocEditor.vue?vue&type=template&id=0b98bf1d&scoped=true&"
import script from "./GrapesDocEditor.vue?vue&type=script&lang=js&"
export * from "./GrapesDocEditor.vue?vue&type=script&lang=js&"
import style0 from "./GrapesDocEditor.vue?vue&type=style&index=0&id=0b98bf1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98bf1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b98bf1d')) {
      api.createRecord('0b98bf1d', component.options)
    } else {
      api.reload('0b98bf1d', component.options)
    }
    module.hot.accept("./GrapesDocEditor.vue?vue&type=template&id=0b98bf1d&scoped=true&", function () {
      api.rerender('0b98bf1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/docBuilder/components/GrapesDocEditor.vue"
export default component.exports